/**
 * @returns the number of items in the cart
 */
export const cartSize = (
  cart?: { products?: ReadonlyArray<{ count: number }> } | null
): number =>
  (cart?.products ?? []).reduce(
    (runningTotal, { count }) => runningTotal + count,
    0
  );
